/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OwnersControllerFindOneQueryResponse, OwnersControllerFindOnePathParams, OwnersControllerFindOneQueryParams, OwnersControllerFindOne400, OwnersControllerFindOne401, OwnersControllerFindOne403, OwnersControllerFindOne404 } from "../../models/ownersController/OwnersControllerFindOne";

function getOwnersControllerFindOneUrl(id: OwnersControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/owners/${id}` as const }  
  return res
}

/**
 * @summary Get an owner by ID
 * {@link /api/v1/owners/:id}
 */
export async function ownersControllerFindOne(id: OwnersControllerFindOnePathParams["id"], params?: OwnersControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<OwnersControllerFindOneQueryResponse, ResponseErrorConfig<OwnersControllerFindOne400 | OwnersControllerFindOne401 | OwnersControllerFindOne403 | OwnersControllerFindOne404>, unknown>({ method : "GET", url : getOwnersControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}